export interface NotificationItem {
  id: string;
  title: string;
  description: string;
  timeAgoLabel: string;
  unread: boolean;
}

// Cobre os tipos de notificação listados na seção 21 do PRD: pagamento, convites,
// prazo de reserva, aulas, cancelamento/reembolso, torneios e lista de espera.
export const NOTIFICATIONS: NotificationItem[] = [
  {
    id: 'lista-espera-promovida',
    title: 'Você foi promovido da lista de espera!',
    description: 'Uma vaga na categoria Masculina B abriu. Confirme sua inscrição e pagamento.',
    timeAgoLabel: 'há 2 min',
    unread: true,
  },
  {
    id: 'pagamento-confirmado',
    title: 'Pagamento confirmado',
    description: 'Sua cota de R$ 20,80 na Arena Praia Norte foi confirmada.',
    timeAgoLabel: 'há 5 min',
    unread: true,
  },
  {
    id: 'convite-dupla',
    title: 'Convite de dupla',
    description: 'Júlia M. aceitou seu convite para o Open Praia Norte.',
    timeAgoLabel: 'há 1h',
    unread: true,
  },
  {
    id: 'inscricao-confirmada',
    title: 'Inscrição confirmada',
    description: 'Sua inscrição na categoria Feminina Open foi confirmada.',
    timeAgoLabel: 'há 1h',
    unread: false,
  },
  {
    id: 'reserva-expirando',
    title: 'Reserva prestes a expirar',
    description: 'Faltam 15 min para o prazo da reserva #10428.',
    timeAgoLabel: 'há 2h',
    unread: false,
  },
  {
    id: 'torneio-publicado',
    title: 'Novo torneio disponível',
    description: 'Copa Aldeota de Pickleball já está com inscrições abertas.',
    timeAgoLabel: 'há 3h',
    unread: false,
  },
  {
    id: 'cancelamento-reembolso',
    title: 'Reserva cancelada pela arena',
    description: 'Areia 1 entrou em manutenção. R$ 60,00 foram reembolsados automaticamente.',
    timeAgoLabel: 'ontem',
    unread: false,
  },
  {
    id: 'lembrete-aula',
    title: 'Lembrete de aula',
    description: 'Sua aula da Turma B começa amanhã às 07:00.',
    timeAgoLabel: 'ontem',
    unread: false,
  },
];
